module.exports = __webpack_public_path__ + "static/img/icon_time.1741d4e3.png";